import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAllCmsStart, updateSACMSStatusStart, deleteCMSStart , deleteCMSSuccess} from '../../../../store/redux-slices/fetchData'
import useDidMountEffect from '../../../../utils/useDidMountEffect'
import { toast } from '../../../../components/Toast'
// mport { getAllAffiliatesStart } from '../../../store/redux-slices/fetchData'

const useCmsListing = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const isInitialRender = useDidMountEffect()

  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [status, setStatus] = useState('')
  const [active, setActive] = useState('')
  const [statusShow, setStatusShow] = useState(false)
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    title: '',
  });

  const [statusConfirmation, setStatusConfirmation] = useState({
    open: false,
    id: "",
    status: "",
    name: "",
  })

  const [cmsId, setCmsId] = useState('')
  const [tenantId, setTenantId] = useState('')
  const [name, setName] = useState()

  const { cmsData, loading, CMSDeleteData } = useSelector((state) => state.fetch)
  const totalPages = Math.ceil(cmsData?.count / limit)

  const fetchCMS = () => {
    dispatch(
      getAllCmsStart({
        limit,
        pageNo: page,
        tenantId: selectedPortal,
        adminId: selectedClient,
        search,
        isActive: active
      })
    )
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          fetchCMS()
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])
  useEffect(() => {
    !isInitialRender && fetchCMS()
  }, [page])

  useEffect(() => {
    setPage(1)
    fetchCMS()
  }, [limit, selectedPortal, selectedClient, active])

  useEffect(() => {
    if (CMSDeleteData?.data?.success) {
      if (CMSDeleteData?.data?.deleted){
        toast("CMS Deleted Successfully", "success");
        setDeleteConfirmation({
          open: false,
          title: '',
          cmsPageId: ""
        })
  
        if (page === 1) {
          fetchCMS()
        } else {
          setPage(1)
        }
        dispatch(deleteCMSSuccess())
      }
      else {
        toast("Failed to delete CMS", "error");

      }
      
      }
    
  }, [CMSDeleteData])

  const handleStatusShow = (id, status, tenantId, myName) => {
    setCmsId(id)
    setStatus(!status)
    setStatusShow(true)
    setTenantId(tenantId)
    setName(myName)
  }

  const handleToggleChange = (data) => {
    console.log('handleToggleChange' ,  data)
    setStatusConfirmation({
      isOpen: true,
      id: data.cmsPageId,
      status: data?.isActive,
      name: data.title.EN,

    })
  }
const onToggleConfirmation = (id, status, name) => {
    
    dispatch(
      updateSACMSStatusStart({
        data: {
          code: 'CMS',
          cmsPageId: statusConfirmation?.id,
          status: !statusConfirmation?.status,
          tenantId
        },
        limit,
        pageNo: page,
        tenantId: selectedPortal,
        adminId: selectedClient,
        search,
        isActive: active
      })
    )

    setStatusConfirmation({ open: false,
      id: "",
      status: "",
      name: "",})
      
  }
  const onCancleToggleStatus = () => {
    setStatusConfirmation({
      id: "",
      status: "",
      name: "",
      isOpen: false
    })
  }

  const handleYes = () => {
    dispatch(
      updateSACMSStatusStart({
        data: {
          code: 'CMS',
          cmsPageId: cmsId,
          status,
          tenantId
        },
        limit,
        pageNo: page,
        tenantId: selectedPortal,
        adminId: selectedClient,
        search,
        isActive: active
      })
    )
    setStatusShow(false)
  }

  const onHandleDeleteCms = () => {
    dispatch(deleteCMSStart({
      cmsPageId: deleteConfirmation?.cmsPageId,
      language: "EN"
    }))
  }
  return {
    navigate,
    limit,
    page,
    search,
    selectedClient,
    setPage,
    setLimit,
    setSearch,
    setSelectedClient,
    cmsData,
    totalPages,
    selectedPortal,
    setSelectedPortal,
    loading,
    handleStatusShow,
    statusShow,
    setStatusShow,
    handleYes,
    status,
    active,
    setActive,
    name,
    setDeleteConfirmation,
    deleteConfirmation,
    onHandleDeleteCms,
    handleToggleChange,
    statusConfirmation,
    onCancleToggleStatus,
    onToggleConfirmation,
  }
}

export default useCmsListing
